import React, { Component } from 'react';
import { Segment, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import { authExternalUser, fetchUser } from '../actions/user';
import { LocalStorage } from '../helpers/storage';
import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import axios from 'axios';

class ExternalLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      pageError: '',
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const token = queryParams.get('access_token');
    const user_external_id = queryParams.get('user_external_id');

    console.log('Token:', token);
    console.log('User External ID:', user_external_id);

    if (!token || !user_external_id) {
      this.setState({ pageError: 'Missing access_token or user_external_id parameters', loading: false });
      return;
    }

    // Önce mevcut storage'ı temizle
    LocalStorage.clear();
    
    // Token'ı ayarla
    window.$$token = token;
    LocalStorage.set('token', token);
    LocalStorage.set('user_external_id', user_external_id);
    
    // Axios header'ını ayarla
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // Auth işlemini gerçekleştir
    this.props.authExternalUser(token, user_external_id)
      .then(response => {
        if (response.access_token) {
          // Kullanıcı bilgilerini getir
          this.props.fetchUser()
            .then(data => {
              if (data && data.account_access_token) {
                LocalStorage.set('account_access_token', data.account_access_token);
                
                // Yönlendirme
                if (isMobile) {
                  window.location.replace('/marketdb');
                } else {
                  window.location.replace('/demandfc');
                }
              } else {
                throw new Error('Invalid user data');
              }
            })
            .catch(error => {
              console.error('Fetch user error:', error);
              this.setState({ pageError: 'Failed to fetch user data', loading: false });
            });
        } else {
          this.setState({ pageError: 'Authentication failed', loading: false });
        }
      })
      .catch(err => {
        console.error('Auth error:', err);
        this.setState({ pageError: 'Authentication process failed', loading: false });
      });
  }

  render() {
    const { loading, pageError } = this.state;

    return (
      <div className="login-wrapper">
        <div className="login-form">
          <Segment textAlign="center" loading={loading}>
            {loading ? (
              <Loader active inline='centered'>Authenticating...</Loader>
            ) : (
              pageError && <div className="ui negative message">
                <div className="header">Error</div>
                <p>{pageError}</p>
              </div>
            )}
          </Segment>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userInfo, error, fetched } = state.user;
  return { userInfo, error, fetched, cookies: ownProps.cookies };
};

export default withTranslation()(withCookies(
  connect(mapStateToProps, {
    authExternalUser,
    fetchUser,
  })(ExternalLogin)),
); 